/* Scattered Babe Society — theme.js */

document.addEventListener('DOMContentLoaded', function () {
  // Pause marquee for reduced motion
  const marquee = document.querySelector('.marquee');
  if (marquee && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    marquee.style.animation = 'none';
  }

  // Quantity selectors
  document.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const dir = btn.dataset.qtyBtn;
      let val = parseInt(input.value || '1', 10);
      val = dir === 'plus' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  });
});

/* ===== Mobile hamburger menu ===== */
document.addEventListener('DOMContentLoaded', function () {
  var burger = document.getElementById('sbsBurger');
  var menu = document.getElementById('sbsMobileMenu');
  var closeBtn = document.getElementById('sbsMobileClose');
  var overlay = document.getElementById('sbsMobileOverlay');
  if (!burger || !menu) return;

  function openMenu() {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
});

/* ===== Product gallery + variant image swap ===== */
document.addEventListener('DOMContentLoaded', function () {
  var galleryMain = document.querySelector('.product__gallery-main');
  if (!galleryMain) return;

  var images = Array.prototype.slice.call(galleryMain.querySelectorAll('.product__gallery-img'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product__thumb'));
  var selects = Array.prototype.slice.call(document.querySelectorAll('.product__option-select'));
  var hiddenId = document.getElementById('selectedVariantId');

  // Parse variant data
  var variantData = [];
  var vdEl = document.getElementById('variantData');
  if (vdEl) { try { variantData = JSON.parse(vdEl.textContent); } catch (e) {} }

  function showMedia(mediaId) {
    if (!mediaId) return;
    var matched = false;
    images.forEach(function (img) {
      var isMatch = String(img.dataset.mediaId) === String(mediaId);
      img.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId));
    });
    // scroll active thumb into view
    var activeThumb = thumbs.find(function (t) { return String(t.dataset.mediaId) === String(mediaId); });
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  // Thumbnail clicks
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMedia(thumb.dataset.mediaId);
    });
  });

  // Match selected options to a variant, swap image + update hidden id
  function onVariantChange() {
    if (!variantData.length) return;
    var chosen = selects.map(function (s) { return s.value; });
    var match = variantData.find(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    });
    if (match) {
      if (hiddenId) hiddenId.value = match.id;
      if (match.media_id) showMedia(match.media_id);
    }
  }

  selects.forEach(function (s) {
    s.addEventListener('change', onVariantChange);
  });
});
